<template>
    <div>
        <TableList
            ref="table_list"
            style_mode="pop"
            :columns="columns"
            :slot_table_list="['department','role_name']"
			:where='where'
            :is_created_get_list="true"
            :get_table_list="get_table_list"
            :form_data_seo="form_data_seo"
			rowKey="id"
        >
            <template slot="role_name" slot-scope="data">
				<span v-for="it in data.record.role_name_new">
				{{it}} <br v-if='data.record.role_name_new.length>1' />
				</span>
			</template>
			
			<template slot="department" slot-scope="data">
				<span v-for="it in data.record.department_join.department_list">
				{{it}} <br v-if='data.record.department_join.department_list.length>1' />
				</span>
			</template>
        </TableList>
    </div>
</template>

<script>
    import TableList from "@/components/TableList";
    import {user_index} from "@/api/user";

    export default {
        components: {
            TableList
        },
        props: {
            ruleDepartmentData: {
                type: String,
                default: ''
            },
            ruleRoleData: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                get_table_list:user_index,
                form_data_seo: {
                    list: [
                        {
                            type: "text",
                            name: "keyword",
                            title: "员工",
                            placeholder: '姓名/ID/手机号',
                            options: {}
                        },
                    ],
                    ...this.$config.form_data_seo
                },

                columns:[
                    {
                        title: "姓名",
                        dataIndex: "username",
                    },
                    {
                        title: "部门",
                        dataIndex: "department",
                        scopedSlots: {
                            customRender: "department"
                        }
                    },
                    {
                        title: "岗位",
                        dataIndex: "role_name",
                    },
                    {
                        title: "电话",
                        dataIndex: "phone",
                    },
                ],

                where:{
                    department_id:'',
                    role_id:'',
                    status:"1",
                },

            }
        },
        watch: {
            ruleDepartmentData: {
                handler(newValue, oldValue) {
                    this.where.department_id = newValue
                    this.$refs.table_list.rest_get_list();
                }
            },
            ruleRoleData: {
                handler(newValue, oldValue) {
                    this.where.role_id = newValue
                    this.$refs.table_list.rest_get_list();
                }
            },
        },
        created() {
            this.where.department_id = this.ruleDepartmentData
            this.where.role_id = this.ruleRoleData
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    
</style>